import { AfterViewChecked, Component, Inject, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceEcoleInfo } from '../../models/produit.model';
import { ProduitService } from '../../services/produit.service';
import { B2b, CoursForfait } from '../../models/produit.model';
import { Prof } from '../../models/personne.model';

import { environment } from '../../../environments/environment';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'service-ecole',
  templateUrl: './serviceEcole.component.html',
  styleUrls: ['./serviceEcole.component.scss']
})
export class ServiceEcoleComponent implements OnInit, AfterViewChecked {
  environment =  environment;

  @Input() id_instance: number;
  titre_produit: string;
  nom_instance: string;
  prof: Prof;
  isLoadingServiceEcoleInfo = true;
  isLoadingB2b = true;
  isLoadingProf = true;
  @Input() service_ecole_info: ServiceEcoleInfo;
  b2b: B2b;
  course_column_1: CoursForfait[] = new Array<CoursForfait>();
  course_column_2: CoursForfait[] = new Array<CoursForfait>();
  isDarkBg = false;
  titre_produit_readable: string;
  url_instance: string;

  contactEcoleLink = '';

  constructor(
    private produitService: ProduitService,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.route.params.subscribe( params => {
        this.id_instance = params.id_instance;
        this.titre_produit = params.titre_produit;
        this.nom_instance = params.nom_instance;
        this.url_instance = params.url_instance;
    } );
  }

  ngOnInit() {
    this.getServiceEcoleById(this.id_instance);
    this.contactEcoleLink = this.getContactEcoleLink();
  }

  setTags() {
      this.titleService.setTitle('Externalisation ' + this.titre_produit_readable);
      this.metaTagService.updateTag({
        name: 'description',
        content: 'Externalisation ' + this.titre_produit_readable + ', service pour Etablissements scolaires'
      });
    }

  ngAfterViewChecked() {
    if (!this.isLoadingServiceEcoleInfo) {
      this.initColors();
      this.setBandeau();
    }
  }

  handleServiceInfoRecover() {
    if (this.service_ecole_info.titre_produit) {
      this.titre_produit_readable = this.service_ecole_info.titre_produit.split('<br>').join('');
    }
    if (this.service_ecole_info.id_b2b) {
      this.getB2b(this.service_ecole_info.id_b2b);
    } else { this.isLoadingB2b = false; }
    if (this.service_ecole_info.url_instance) {
      this.url_instance = this.service_ecole_info.url_instance;
    }
    this.setTags();
    this.isLoadingServiceEcoleInfo = false;
  }

  getServiceEcoleById(id_instance) {
    this.produitService.getServiceEcoleById(id_instance.toString()).subscribe(
      (res: ServiceEcoleInfo) => {
        this.service_ecole_info = res;
        this.handleServiceInfoRecover();
      },
      (err) => {
        console.log(err);
        this.isLoadingServiceEcoleInfo = false;
        this.isLoadingB2b = false;
      }
    );
  }

  getB2b(id_b2b): void {
      this.produitService.getB2b(id_b2b.toString()).subscribe(
          (res: B2b) => {
              this.b2b = res;
              if (this.b2b.prof) {
                this.prof = this.b2b.prof;
                if (this.b2b.cours) {
                  this.sortCourseColumns();
                }
                this.isLoadingProf = false;
              } else { this.isLoadingProf = false; }
              this.isLoadingB2b = false;
              this.isLoadingProf = false;
          },
          (err) => {
            console.log(err);
            this.isLoadingB2b = false;
          }
      );
  }

  sortCourseColumns() {
    let total_length = 0;
    let nb_cours = 0;
    this.b2b.cours.forEach(cours => {
        total_length = total_length + cours.commentaire.length;
        nb_cours++;
    });
    if (nb_cours === 1) {
        this.course_column_1.push(this.b2b.cours[0]);
    } else if (nb_cours === 2) {
        this.course_column_1.push(this.b2b.cours[0]);
        this.course_column_2.push(this.b2b.cours[1]);
    } else if (nb_cours > 2) {
        const mid_length = Math.trunc(total_length / 2);
        let current_length = 0;
        this.b2b.cours.forEach(cours => {
            current_length = current_length + cours.commentaire.length;
            if (current_length < mid_length + 200) {
                this.course_column_1.push(cours);
            } else {
                this.course_column_2.push(cours);
            }
        });
    }
  }

  getContactEcoleLink() {
    return'/services-aux-etablissements-scolaires-contact/' + this.url_instance;
  }

  initColors() {
    if (this.service_ecole_info && this.service_ecole_info.couleur_box) {
      this.setColors('.text-color', 'transparent', this.service_ecole_info.couleur_box);
      this.setColors('.custom-background-color', this.service_ecole_info.couleur_box, '');
    } else {
      // default colors
      this.setColors('.text-color', 'transparent', '#6492A9');
      this.setColors('.custom-background-color', '#6492A9', '');
    }
    if (this.service_ecole_info && this.service_ecole_info.couleur_texte) {
      this.setColors('.custom-color', 'transparent', this.service_ecole_info.couleur_texte);
    }
  }

  setColors(ClassName, backgroundColor, textColor) {
    if (isPlatformBrowser(this.platformId)) {
      const elements = document.querySelectorAll(ClassName);
      const array = Array.from(elements);
      array.forEach(element => element.style.backgroundColor = backgroundColor);
      array.forEach(element => element.style.color = textColor);
    }
  }

  setBandeau() {
    if (isPlatformBrowser(this.platformId)) {
      const element = <HTMLDivElement> document.querySelector('.cover-photo');
      if (element) {
        if (this.service_ecole_info && this.service_ecole_info.bandeau) {
          element.style.backgroundImage = 'url(\'https://www.apprentissage-montpellier.education/img/bandeaux/' + this.service_ecole_info.bandeau + '\')';
        } else {
          element.style.backgroundImage = 'url(\'https://www.apprentissage-montpellier.education/img/bandeaux/bandeau_hp.jpg\')';
        }
      }
    }
  }
}
